import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { v4 as uuidv4 } from 'uuid';

const StyledLink = styled(Link)`
  padding-bottom: 16px;
  font-family: elsevier-sans;
  font-size:20px;
`

const OuterContainer = styled.div`
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  position: absolute;
  right: 0;
  margin: 16px auto 0;
  z-index: 5;
  
  padding: 16px;
  border-top: 2px solid #ff6c00;
  background: rgba(235, 235, 235, 0.85);
  max-width: calc(100vw - 32px);

  &:before {
    position: absolute;
    top: -13px;
    right: 0;
    content: ' ';
    width: 0;
    height: 0;
    border-top: 6.5px solid transparent;
    border-left: 6.5px solid transparent;
    border-right: 6.5px solid #ff6c00;
    border-bottom: 6.5px solid #ff6c00;
  }
`

const InnerContainer = styled.div`
  background: white;
  padding: 16px;
  max-width: 100%;
  text-align: left;
  white-space: nowrap;
  z-index: 5;
  position: relative;

  &:after {
    position: absolute;
    right: 0;
    content: ' ';
    width: 0;
    height: 0;
    border-top: 6.5px solid transparent;
    border-left: 6.5px solid transparent;
    top: -10px;
    border-right: 6.5px solid #ebebeb;
    border-bottom: 6.5px solid #ebebeb;
  }
`

const StyledText = styled.p`
  color: ${props => props.theme.colors.grey4};
  font-family: elsevier-sans;
  font-size: 20px;
  line-height: 28px;
  position: relative;
  z-index: 5;
  width: fit-content;
  margin-bottom: 16px !important;
  :after {
    background-color: transparent;
    transition: background-color 0.3s, bottom 0.2s;
    content: '';
    position: absolute;
    bottom: -4px;
    right: 0;
    left: 1px;
    height: 2px;
    background-color: transparent;
    pointer-events: none;
  }
  &:hover {
    :after {
      background-color: #ff6c00 !important;
    }
  }
`

class HoverMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = { visible: false }
  }

  render() {
    const { menuItems, to, label } = this.props
    const { visible } = this.state
    return (
      <div
        onMouseEnter={() => this.setState({ visible: true })}
        onMouseLeave={() => this.setState({ visible: false })}
      >
        <StyledLink
          className="anchor button-link-primary gh-nav-action"
          to={to}
          tabIndex="0"
          id="5dfa035a-1b45-4b54-9bb8-dc50cf439c21"
          data-aa-region="aa-globalheader-navigation-link1"
          data-aa-name="aa-globalheader-navigation-Language editing"
          label={label}
        >
          <span className="anchor-text">{label}</span>
        </StyledLink>
        <OuterContainer visible={visible}>
          <InnerContainer>
            {menuItems.map(menuItem => (
              <Link
                to={menuItem.link}
                key={uuidv4()}
              >
                <StyledText>{menuItem.title}</StyledText>
              </Link>
            ))}
          </InnerContainer>
        </OuterContainer>
      </div>
    )
  }
}

export default HoverMenu
